import { defaultConfig, defineRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const spinnerRecipe = defineRecipe(
    merge(defaultConfig?.theme?.recipes?.spinner, {
        variants: {
            size: {
                lg: {
                    '--spinner-size': '2.0625rem', // 33px
                },
            },
        },
    }),
);
